import { render, staticRenderFns } from "./ShiftsMap.vue?vue&type=template&id=0de9c908"
import script from "./ShiftsMap.vue?vue&type=script&lang=js"
export * from "./ShiftsMap.vue?vue&type=script&lang=js"
import style0 from "./ShiftsMap.vue?vue&type=style&index=0&id=0de9c908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports